import { useRef } from 'react';
import TextField from '@mui/material/TextField';
import { bytesToSize } from '../global/helpers';
import Resizer from 'react-image-file-resizer';

const resizeFile = file =>
    new Promise(resolve => {
        Resizer.imageFileResizer(
            file,
            300,
            300,
            'JPEG',
            100,
            0,
            uri => resolve(uri),
            'base64',
        );
    });

const mimeTypes = ['application/pdf', 'image/jpg', 'image/png', 'image/jpeg'];

export default ({ name, onChange, handleBlur, inputRef }) => {
    const internalRef = useRef();
    const refInputFile = inputRef ?? internalRef;

    const handleFile = async data => {
        if (!data || !mimeTypes.includes(data.type)) return;

        try {
            const image = await resizeFile(data);
            onChange({
                base64: image.replace(
                    /^data:image\/(?:gif|png|jpeg|bmp|webp)(?:;charset=utf-8)?;base64,/,
                    '',
                ),
                name: data.name,
                size: bytesToSize(data.size),
                preview: URL.createObjectURL(data), 
            });
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <TextField
            inputRef={refInputFile}
            type="file"
            accept="image/jpeg,image/png,image/jpg"
            onChange={e => handleFile(e.target.files[0])}
            onBlur={handleBlur}
            style={{ display: 'none' }}
        />
    );
};
